import { render, staticRenderFns } from "./CurrentPlayerHeader.vue?vue&type=template&id=205ebb60&scoped=true&"
import script from "./CurrentPlayerHeader.vue?vue&type=script&lang=js&"
export * from "./CurrentPlayerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ebb60",
  null
  
)

export default component.exports